<style scoped>
.modal{
    display: block;
    overflow: auto !important;
    padding: 0 !important;
    z-index: 1058;
}
.babado{
    background-color: rgba(0,0,0,0.2);
    z-index: 1058;
}
.modal-dialog {
  z-index: 1;
}
footer{
    padding-bottom: 0px;
}
/* Largura da barra de rolagem */
::-webkit-scrollbar {
    width: 0px;
}
</style>
<template>
<div>
    <!-- <form> -->
        <transition-group name="custom-classes-transition"
            enter-active-class="animated slideInDown"
            leave-active-class="animated slideOutUp"
            >
            <div class="modal-backdrop text-dark babado" v-if="this.modalOpen" :key="'1'" id="do_Modal">
            </div>
            <div v-bind:id="modalid" class="modal" role="dialog" aria-hidden="true" data-keyboard="false" data-backdrop="static" v-if="this.modalOpen" :key="'2'">
                <div id="modal_body" class="modal-dialog modal-dialog-centered" :class="(profile==1)?'modal-xl':''" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                <header>
                                    <slot name="header"></slot>
                                </header>
                            </h5>
                            <button type="button" class="close bg-danger btn-danger" @click.prevent="close" aria-label="Fechar">
                            <span aria-hidden="true"><i class="fas fa-times"></i></span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <main>
                                <slot name="main"></slot>
                            </main>
                        </div>
                        <div class="modal-footer flex-row justify-content-between flex-wrap">
                            <button type="button" class="btn btn-danger float-left" @click.prevent="close" v-tooltip="'Clique para fechar.'"><i class="fa fa-times"></i> Cancelar</button>
                            <footer>
                                <slot name="footer" class="float-right"></slot>
                            </footer>
                            <!-- <button type="button" class="btn btn-secondary"  @click.prevent="close('inner')">Fechar</button>
                            <button type="button" class="btn btn-primary">Salvar mudanças</button> -->
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    <!-- </form> -->
</div>
</template>
<script>
export default {
    name: 'modal',
    data(){
        return {
        }
    },
    props:{
        modalOpen: {
            required:true,
        },
        form: {
            required:true,
        },
        profile: {
            required: true,
        },
        modalid: {
            String,
            required: true,
        },
        maximized: {
            required: false,
        },
        closeOnEsc: {
            required: false
        }
    },
    mounted(){
        if(this.closeOnEsc == true || typeof this.closeOnEsc == 'undefined'){
            document.addEventListener('keydown', (e) => {
                if(this.modalOpen){
                    if (e.keyCode == 27) {
                        this.close(e);
                    }
                }
            });
        }
        /* $('#'+this.modalid).click((e)=>{
            if(e.target.id === this.modalid){
                this.close(e);
            }
        });  */
    },
    methods: {
        close(e) {
            this.$emit('close');
        }
    }
}
</script>